import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-portal-navigation',
  templateUrl: './portal-navigation.component.html',
  styleUrls: ['./portal-navigation.component.css']
})
export class PortalNavigationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
